// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"329e8d69","163":"2babe4a5","739":"d5a84f6a"}[chunkId] + ".chunk.css";
};